// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3gjOu","rootCenter":"LoadMoreObserver_rootCenter__1Wz6t","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2BZXm"};